<template>
  <v-tooltip v-if="webhook.event"
             left>
    <template v-slot:activator="{on, attrs}">
      <v-chip label
              small
              v-bind="attrs"
              v-on="on"
              :color="color"
              :dark="darkMode"
              class="text-center font-weight-bold"
              :class="{'d-block': block}">
        <v-icon v-if="icon"
                left
                x-small>
          fas fa-fw {{ icon }}
        </v-icon>
        {{ event.text }}
      </v-chip>
    </template>
    <div>
      {{ event?.text }}
    </div>
    <div v-if="eventAt">
      {{ eventAt | datetime }}
    </div>
  </v-tooltip>
</template>
<script>
import mailgunService from '../../../../../ml/services/mailgunService';
import {find} from 'lodash';

export default {
  props: {
    webhook: {
      type: Object,
      required: true,
    },
    block: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    event() {
      return find(mailgunService.getStatusCodes(), s => { // MLD-7793
        if (s.id.toLowerCase() === 'clicked' && this.webhook.is_bot) {
          return s.id.toLowerCase() === 'bot clicked';
        }
        return s.id.toLowerCase() === this.webhook.event
      });
    },
    darkMode() {
      return this.event?.darkMode ?? true;
    },
    color() {
      return this.event?.color ?? '';
    },
    icon() {
      return this.event?.icon ?? '';
    },
    eventAt() {
      return this.webhook.event_at;
    },
  }
}
</script>
